import React, { useEffect, useState, useMemo, useCallback } from "react";
import axios from "axios";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import { baseURL } from "../../constants/pathnames";
import { useHistory } from "react-router-dom";
import Button from "../Button/Button";

const UserAds = ({ userid }) => {
  const { token } = useSelector((state) => state.users);
  const history = useHistory();
  const header = useMemo(() => {
    const headers = {
      headers: {
        Authorization: `jwt ${token}`,
      },
    };
    return headers;
  }, [token]);

  const [issearchinput, setIsSearchinput] = useState(false);
  const [searchinput, setSearchinput] = useState("");
  const [data, setData] = useState([]);
  const [next, setNext] = useState("");

  const getData = useCallback(() => {
    debugger;
    axios
      .get(
        `${baseURL}product/panel/user/${userid}/${
          searchinput ? "?search=" + searchinput : ""
        }`,
        header
      )
      .then((res) => {
        console.log(res.data);
        setData(res.data.results);
        setNext(res.data.next);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [userid, header, searchinput]);
  useEffect(() => {
    getData();
  }, [getData]);
  const getNextList = () => {
    debugger;
    if (next != null) {
      axios
        .get(next, header)
        .then((res) => {
          console.log("res", res.data);
          setData([...data, ...res.data.results]);
          setNext(res.data.next);
        })
        .catch((err) => {
          console.log("err", err.response);
        });
    }
  };

  return (
    <>
      {data?.length > 0 ? (
        <div className='my-10 shadow rounded-xl overflow-x-hidden mx-1'>
          <div className='flex justify-between items-center mx-3 py-5'>
            <div className='text-xl font-semibold mr-5'>کالاهای ثبت شده </div>
            {/* search */}
            <div
              className={`m-1 py-2 px-2 rounded-lg shadow cursor-pointer h-8 w-8 flex justify-center items-center${
                issearchinput ? "flex justify-between items-center w-64" : ""
              } `}
            >
              {issearchinput && (
                <input
                  // className='transition-all'
                  placeholder='جست و جوی کالا'
                  defaultValue={searchinput}
                  // value={filters?.search}
                  onChange={(e) => {
                    const { value } = e.target;
                    setSearchinput(value);
                  }}
                />
              )}
              <img
                // className='transition-all'
                src='/statics/images/search.svg'
                width='16'
                alt='eye'
                onClick={() => {
                  setIsSearchinput(!issearchinput);
                }}
              />
            </div>
          </div>

          <InfiniteScroll
            className='w-100'
            dataLength={data?.length}
            next={() => getNextList()}
            hasMore={true}
            loader={
              next ? (
                <div className='mx-auto w-max color-blue'>در حال جستجو...</div>
              ) : (
                ""
              )
            }
            scrollableTarget='scrollableDiv'
          >
            <div
              className='overflow-y-scroll scroll-style px-2 h-full ltr mx-1'
              id='scrollableDiv'
              style={{ maxHeight: "70vh" }}
            >
              <div className='grid grid-cols-1 md:grid-cols-5 gap-1 rtl'>
                {data.map((row, index) => (
                  <div key={row?.id} className='mx-4 rtl'>
                    <div
                      className='h-36 flex flex-col justify-between items-center content-center rounded-xl shadow-lg border border-gray-200 my-5 w-full'
                      onClick={() => {}}
                    >
                      <div className='w-full relative h-full'>
                        {row?.image ? (
                          <img
                            className='absolute -top-4 -right-4 w-28 h-28 rounded-xl'
                            src={row?.image.image}
                            width='100px'
                            height='100px'
                            alt='arrow'
                          />
                        ) : (
                          <img
                            className='absolute -top-4 -right-4 bg-gray-200 p-8 w-28 h-28 rounded-xl'
                            src='/statics/images/no_picture.svg'
                            width='100px'
                            height='100px'
                            alt='arrow'
                          />
                        )}
                        <div className='mr-28 my-auto py-3 h-full text-xs'>
                          <div className='h-full'>{row?.name}</div>
                        </div>
                      </div>

                      <div className='w-full flex justify-between items-center px-3 py-2'>
                        <div className='font-10'>کد آگهی: {row?.id}</div>
                        <Button
                          maxHeight='25px'
                          maxWidth='90px'
                          fontSize='10px'
                          borderRadius='5px'
                          margin='0'
                          title='مدیریت'
                          onClick={() => {
                            history.push("/adsdetail/" + row?.id);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </InfiniteScroll>
        </div>
      ) : null}
    </>
  );
};

export default UserAds;
